import React, { useEffect } from 'react';
import { getScreenName } from '../../../Utils/helper';
import {
  AddedBonusContainer,
  AddedBousHeading,
  BonusSubheading,
} from './styled';
import { fireEvent } from '../../../Utils/fireEvent';

export default function AddedBonus(props) {
  const { element, index } = props;
  useEffect(() => {
    fireEvent({
      category: 'served_section_in_myloshop',
      screen_name: getScreenName(),
      section_id: '',
      section_name: element?.heading,
      shape: 'Banner',
      page_url: window.location.href.slice(0, 99),
    });
  }, []);
  return (
    <AddedBonusContainer>
      <AddedBousHeading>{element?.items[0]?.heading}</AddedBousHeading>
      <BonusSubheading>{element?.items[0]?.subHeading1}</BonusSubheading>
      <BonusSubheading>{element?.items[0]?.subHeading2}</BonusSubheading>
    </AddedBonusContainer>
  );
}
